import React from "react";

const ProductVariants = ({
  variantProducts,
  setSelectedVariantProduct,
  selectedVariantProduct,
}) => {
  return (
    <>
      <h3 className="text-lg font-semibold mb-3">Variants</h3>
      <div
        className={`grid gap-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 `}
      >
        {variantProducts.map((variantProduct) => (
          <div
            onClick={() => setSelectedVariantProduct(variantProduct)}
            className={`bg-surface border border-border rounded-lg overflow-hidden hover:border-secondary-300
            ${
              selectedVariantProduct?.iProductId === variantProduct.iProductId
                ? "shadow-md transition-smooth"
                : ""
            }
              cursor-pointer group`}
          >
            <div
              className={`relative aspect-square bg-secondary-100 overflow-hidden p-3  `}
            >
              <img
                src={(() => {
                  try {
                    if (!variantProduct) return "";
                    let images;
                    if (typeof variantProduct.aImageJson === "string") {
                      images = JSON.parse(variantProduct.aImageJson);
                    } else if (Array.isArray(variantProduct.aImageJson)) {
                      images = variantProduct.aImageJson;
                    } else {
                      return "";
                    }
                    if (!Array.isArray(images)) return "";
                    const frontImage = images.find(
                      (img) => img?.sTag === "frontImage"
                    );
                    const frontFullImage = images.find(
                      (img) => img?.sTag === "frontFullImage"
                    );
                    return (
                      frontImage?.sURL ||
                      frontFullImage?.sURL ||
                      images?.[0]?.sURL ||
                      ""
                    );
                  } catch (error) {
                    console.warn("Error extracting image URL:", error);
                    return "";
                  }
                })()}
                alt={variantProduct.sProductName}
                className="w-full h-full object-contain "
              />
            </div>

            <div className="p-4">
              <div className="mb-2">
                <h3 className="font-medium text-text-primary line-clamp-2 mb-1">
                  {variantProduct.sProductName}
                </h3>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default ProductVariants;
